import React, { FC, HTMLAttributes } from 'react';

interface TableHeadItemProps extends HTMLAttributes<HTMLTableCellElement> {
    item: string
}

const TableHeadItem: FC<TableHeadItemProps> = ({ item }) => {
    return (
        <td title={ item }>
            { item }
        </td>
    );
};

export default TableHeadItem;